import { playloadCreator } from "../../../utilities";
import snackbar from "components/snackbar";
import setLoading from 'components/loading';
import { isEditMode } from "../../../utils";

const reviewHasErrors = (tabsArray, state, photoIDs) => {
    const hasError = photoIDs.some((photo) => photo.hasError)
    if (!isEditMode() && hasError) return hasError
    
    const sectionNames = tabsArray.slice(0, tabsArray.length - 1)

    for (let section of sectionNames) {
        const sectionState = state[section]

        if (Array.isArray(sectionState)) {
            const hasError = sectionState.some((subsection) => subsection.hasError)
            if (hasError) return hasError

        } else {
            const hasError = sectionState.hasError ? true: false;
            if (hasError) return hasError
        }

    }
}

const noNewUpload = ({ uploadedDoc, optionalDocs }) => {
    const noOptionalDoc = optionalDocs.every((d) => !d.optionalDocID)
    return !uploadedDoc.licenseID && !uploadedDoc.payStubID && noOptionalDoc
}

const prepareDocPayload = ({ uploadedDoc, optionalDocs }) => {

    const prevDocs = window.APPLICATION_JSON.documents
    const noUpload = noNewUpload({ uploadedDoc, optionalDocs })
    if (noUpload) return prevDocs

    if (uploadedDoc.licenseID) {
        prevDocs[0] = {
            type: "Driver's License",
            url: {
                uuid: uploadedDoc.licenseID
            }
        }
    }

    if (uploadedDoc.payStubID) {
        prevDocs[1] = {
            type: 'Pay Stub',
            url: {
                uuid: uploadedDoc.payStubID
            }
        }
    }

    const prevOptionalDocs = prevDocs.slice(2)
    const newOptionalDocs = [...optionalDocs]

    newOptionalDocs.forEach((doc, index) => {
        if (doc.optionalDocID) {
            prevOptionalDocs[index] = {
                type: 'optional',
                url: {
                    uuid: doc.optionalDocID
                }
            }
        }
    });

    const updatedDocs = [...prevDocs.slice(0, 2), ...prevOptionalDocs]
    return updatedDocs.filter(d => d.url?.uuid)
}

export default {
    'Review.Button': ({ isEditMode, errorProps }, stateManager) => {
        const { photoIDs } = stateManager.store.getState();
        const { tabsArray, props } = errorProps
        const hasError =  reviewHasErrors(tabsArray, props, photoIDs);

        if (!isEditMode && !hasError) {
            stateManager.setTermsModal(true);
            return
        }
        if(hasError) {
            snackbar({
                message: "Please fix the errors in application",
                args: {type: 'error'}
            });
            return
        }


        setLoading(true)
        const { saved_form } = playloadCreator(stateManager);
        const { uploadedDoc, optionalDocs } = stateManager.store.getState()

        const application = {
            income: {
                salary: 0,
                description: "",
                present: false,
                id: ""
            },
            documents: prepareDocPayload({ uploadedDoc, optionalDocs })
        }

        for (let item in saved_form) {
            if (item == 'saved_form_id' || item == 'lang' || item == 'start_time') continue;
            application[item] = saved_form[item]
        }

        const payload = {
            full: true,
            application,
        }

        stateManager.saveUpdateApplication({ id: window.APPLICATION_JSON.id, ...payload })
            .then((r) => {
                setLoading(false)
                snackbar({
                    message: "Application updated successfully!",
                    args: { type: 'success' }
                });
            })
            .catch((e) => {
                setLoading(false)
                snackbar({
                    message: e?.response?.data?.error || e?.message,
                    args: { type: 'error' }
                });
            })
    }
};


